import React, {useEffect} from 'react';
import './App.css';
import './react-toggle.css';
import {AppRouter} from './components/navigation/AppRouter';
import PulsoidClient from './PulsoidClient';
import {ClarityInit} from './system/ClarityInit';

import * as Sentry from '@sentry/react';
Sentry.init({
  dsn: 'https://d74bca7b8c394612adc7f8b81b515082@glitchtip.omegaparcel.com/6',

  //@ts-ignore
  release: import.meta.env.VITE_CI_COMMIT_SHORT_SHA ?? 'release_not_available',
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  enabled: true,
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === 'fetch' && breadcrumb.data) {
      if (hint) {
        let rpcMethod = 'not-rpc';
        try {
          let inputs = (hint.input as []) ?? [];
          //@ts-ignore
          let input = inputs.find((input) => input.headers);
          //@ts-ignore
          rpcMethod = input?.headers['x-rpc-method'] ?? 'not-rpc';
        } catch (e) {}

        breadcrumb.data['rpc_method'] = rpcMethod;
      }
    }

    return breadcrumb;
  },
});

const App: React.FC = () => {
  useEffect(() => {
    const client = new PulsoidClient();
    (window as any).__PULSOID_CLIENT__ = client;
    (window as any).__PUBLIC_PULSOID_CLIENT__ = new PulsoidClient({
      publicRpc: true,
    });
  }, []);

  return (
    <>
      <link
        rel="stylesheet"
        href="https://maxcdn.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css"
        integrity="sha384-9aIt2nRpC12Uk9gS9baDl411NQApFmC26EwAOH8WgZl5MYYxFfc+NcPb1dKGj7Sk"
        crossOrigin="anonymous"
      />

      <Sentry.ErrorBoundary>
        <ClarityInit />
        <AppRouter />
      </Sentry.ErrorBoundary>
    </>
  );
};

export default App;
